export default __webpack_public_path__ + "static/media/weather.80e10673.png";